import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SearchPagesService } from './core/search-pages.service';
import { Alert, ALERT_TYPE } from '../../../../components/alert/alert.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'search-pages',
  templateUrl: './search-pages.component.html',
  styleUrl: './search-pages.component.scss',
  standalone: false,
})
export class SearchPagesComponent implements OnInit, OnDestroy {
  searchRequest$ = this.searchPagesService.get();
  subscription = new Subscription();
  errorMessage: Alert = {
    isActive: true,
    content: '',
    type: ALERT_TYPE.DANGER,
    hasCloseButton: false,
  };

  currentTerm = '';

  constructor(
    private searchPagesService: SearchPagesService,
    private activeRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.getCurrentTerm();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getCurrentTerm() {
    this.subscription.add(
      this.activeRoute.params.subscribe(params => {
        this.currentTerm = params['query'];
        this.checkPages();
      }),
    );
  }

  checkPages() {
    this.subscription.add(
      this.searchRequest$.subscribe(searchRequest => {
        searchRequest.isPristine && this.searchPagesService.fetch(this.currentTerm, 0);

        if (searchRequest.hasError && searchRequest.message) {
          this.errorMessage.content = searchRequest.message;
        }

        this.cdr.detectChanges();
      }),
    );
  }

  pageChange(page: number): void {
    this.searchPagesService.fetch(this.currentTerm, page);
  }
}
